import React, { useState } from "react";
import "./Contact.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const defaultSecondaryFields = [
  {
    name: "phone",
    placeholder: "Phone / Slack (optional)",
  },
  {
    name: "context",
    placeholder: "Timeline / deadline",
  },
];

const getInitialContactData = (secondaryFields) =>
  ["name", "email", "subject", "message", ...secondaryFields.map((field) => field.name)].reduce(
    (data, fieldName) => ({
      ...data,
      [fieldName]: "",
    }),
    {}
  );

function ContactForm({
  className = "",
  title = "Tell me about the project",
  description = "Share scope, timeline, and the outcome you're aiming for.",
  action = "https://formsubmit.co/kordikmail@gmail.com",
  formSubject = "New portfolio contact request",
  nextUrl = "https://kordik.ca/#contact",
  secondaryFields = defaultSecondaryFields,
  formLabel,
  showSubjectField = true,
  subjectPlaceholder = "Subject",
  messagePlaceholder = "What are you building? Share context, budget, or must-haves.*",
  submitLabel = "Send message",
  hiddenFields = [],
}) {
  const [userContactData, setUserContactData] = useState(() =>
    getInitialContactData(secondaryFields)
  );

  const handleChange = (e) => {
    const { name, value } = e.currentTarget;
    setUserContactData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className={`contact__form-card${className ? ` ${className}` : ""}`}>
      <div className="contact__form-header">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <Form action={action} method="POST" aria-label={formLabel}>
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_subject" value={formSubject} />
        <input type="hidden" name="_next" value={nextUrl} />
        {hiddenFields.map((field) => (
          <input key={field.name} type="hidden" name={field.name} value={field.value} />
        ))}
        <Row xs={1} sm={2} className="contact__row">
          <Col>
            <InputGroup className="mb-3">
              <FormControl
                className="shadow-none"
                placeholder="Name*"
                name="name"
                required
                value={userContactData.name}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
          <Col>
            <InputGroup className="mb-3">
              <FormControl
                className="shadow-none"
                placeholder="Email*"
                type="email"
                name="email"
                required
                value={userContactData.email}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>

        {secondaryFields.length > 0 && (
          <Row xs={1} sm={2} className="contact__row">
            {secondaryFields.map((field) => (
              <Col key={field.name}>
                <InputGroup className="mb-3">
                  <FormControl
                    className="shadow-none"
                    placeholder={field.placeholder}
                    name={field.name}
                    value={userContactData[field.name] || ""}
                    onChange={handleChange}
                  />
                </InputGroup>
              </Col>
            ))}
          </Row>
        )}

        {showSubjectField && (
          <InputGroup className="mb-3">
            <FormControl
              className="shadow-none"
              placeholder={subjectPlaceholder}
              aria-label={subjectPlaceholder}
              name="subject"
              value={userContactData.subject || ""}
              onChange={handleChange}
            />
          </InputGroup>
        )}
        <InputGroup>
          <FormControl
              className="shadow-none form-textarea"
              placeholder={messagePlaceholder}
            as="textarea"
            name="message"
            required
            value={userContactData.message || ""}
            onChange={handleChange}
          />
        </InputGroup>

        <div className="contact__submit">
          <Button variant="warning" type="submit">
            {submitLabel}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default ContactForm;
